/*
 * Indexx ID callback — the single redirect target registered for this product.
 *
 * The browser lands here with ?code=&state=. The client exchanges the code with
 * its PKCE verifier, scrubs the tokens out of the URL, and returns the user to
 * where they were. It renders almost nothing on purpose: this page is on screen
 * for a few hundred milliseconds and anything heavier just flashes.
 */
import { useEffect, useState } from "react";
import { createAuth } from "./zodiacAuth";

export default function AuthCallback() {
  const [message, setMessage] = useState("Signing you in…");

  useEffect(() => {
    const auth = createAuth({
      issuer: process.env.REACT_APP_IDP_ISSUER || "http://localhost:5062",
      clientId: "indexx-exchange",
      redirectUri: window.location.origin + "/auth/callback",
    });
    auth
      .handleCallback()
      .then((result) => {
        // returnTo was captured before the redirect; fall back to the root
        // rather than trusting anything that arrived in the URL.
        window.location.replace((result && result.returnTo) || "/");
      })
      .catch(() => setMessage("Could not complete sign-in. Return to the site and try again."));
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#181A20", color: "#ffffff", fontFamily: "system-ui, sans-serif" }}>
      <p style={{ fontSize: 14, opacity: 0.8 }}>{message}</p>
    </div>
  );
}
